module.exports = __webpack_public_path__ + "static/img/tvb.3cbd701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/top/tvb.png
// module id = MmnO
// module chunks = 1